import type { StatusInfo } from './submissions';

export const ENTITY_STATUS_COLORS = {
  in_progress: '#60a5fa',
  active: '#10b981',
  rejected: '#ef4444',
  suspended: '#f59e0b',
  closed: '#6b7280',
  expired: '#9ca3af',
} as const;

const ENTITY_STATUS_MAP: Record<string, StatusInfo> = {
  in_progress: {
    label: 'In Progress',
    color: ENTITY_STATUS_COLORS.in_progress,
  },
  active: { label: 'Active', color: ENTITY_STATUS_COLORS.active },
  rejected: {
    label: 'Rejected',
    color: ENTITY_STATUS_COLORS.rejected,
  },
  suspended: { label: 'Suspended', color: ENTITY_STATUS_COLORS.suspended },
  closed: { label: 'Closed', color: ENTITY_STATUS_COLORS.closed },
  expired: { label: 'Expired', color: ENTITY_STATUS_COLORS.expired },
};

const DEFAULT_ENTITY_STATUS: StatusInfo = { label: '', color: '#717680' };

export const getEntityStatusInfo = (status: string): StatusInfo => {
  return (
    ENTITY_STATUS_MAP[status] ||
    TEMPLATE_STATUS_MAP[status] || { ...DEFAULT_ENTITY_STATUS, label: status }
  );
};

// Submission template / template version statuses (draft/published/archived).
// Kept out of ENTITY_STATUS_MAP/ENTITY_STATUS_OPTIONS on purpose — those two
// back the Sites/Studies status filter dropdowns (see Sites/index.tsx,
// Studies/index.tsx), and these three values aren't valid filter choices there.
const TEMPLATE_STATUS_COLORS = {
  draft: '#f59e0b',
  published: '#10b981',
  archived: '#9ca3af',
} as const;

const TEMPLATE_STATUS_MAP: Record<string, StatusInfo> = {
  draft: { label: 'Draft', color: TEMPLATE_STATUS_COLORS.draft },
  published: { label: 'Published', color: TEMPLATE_STATUS_COLORS.published },
  archived: { label: 'Archived', color: TEMPLATE_STATUS_COLORS.archived },
};

export const ENTITY_STATUS_OPTIONS = Object.entries(ENTITY_STATUS_MAP).map(
  ([value, { label }]) => ({
    value,
    label,
  })
);
